import useTranslation from 'next-translate/useTranslation'

import useAuth from '@/api/hooks/useAuth'
import Breadcrumbs from '@/atoms/Breadcrumb'
import Section from '@/atoms/Section/Section'

import { FOR_CREATORS_SECTIONS } from './data/for-creators'
import LastSection from './includes/LastSection'
import MainSection from './includes/MainSection'
import ProprietaryProductsSection from './includes/ProprietaryProductsSection'
import WithLineSection from './includes/WithLineSection'

function ForCreatorsPage() {
  const { t } = useTranslation('forCreators')
  const { data: user } = useAuth('user')

  return (
    <div>
      <Breadcrumbs
        crumbs={[{ label: t('global:for_creators') }]}
        className="mb-8"
      />
      <div className="overflow-x-hidden lg:overflow-x-visible box">
        <MainSection />
        <section className="py-8 md:py-16 xl:py-24">
          <WithLineSection />
        </section>
        <section className="py-8 md:py-16 xl:py-24">
          <ProprietaryProductsSection />
        </section>
        <div className="flex flex-col">
          {FOR_CREATORS_SECTIONS.map(({ logo, image, title, text }) => (
            <Section
              key={title}
              logo={logo}
              image={image}
              title={t(title)}
              text={t(text)}
            />
          ))}
        </div>
        {!user && (
          <section>
            <LastSection />
          </section>
        )}
      </div>
    </div>
  )
}

export default ForCreatorsPage
